<template>
  <donut-accordion-radio v-model="formatSelection" :options="optionsWithStatus" class="m-tx2">
    <!-- Default Only -->
    <template #default_only>
      <div class="t">Send same amount of {{ pointsNoun }} each year.</div>
      <bonus-milestone-configs-anniversary-inputs-default class="m-tx2" />
      <div v-emoji="getters['pointsConfig/exchangeRateText']" class="t-sm gray m-t" />
    </template>
    <!-- Milestones and Default -->
    <template #custom_and_default>
      <div class="t">Send different amounts of {{ pointsNoun }} for milestone years and the same amount for all others.</div>
      <bonus-milestone-configs-anniversary-inputs-default class="m-tx2" />
      <bonus-milestone-configs-anniversary-inputs-milestones class="m-tx2" />
    </template>
    <!-- Milestones Only -->
    <template #custom_only>
      <div class="t">Send {{ pointsNoun }} on milestone years only.</div>
      <bonus-milestone-configs-anniversary-inputs-milestones class="m-tx2" />
    </template>
  </donut-accordion-radio>
</template>

<script setup>
  import { computed, inject } from 'vue';
  import { useStore } from 'vuex';
  import useAccordionSaveStatus from 'composables/accordion-save-status';

  const $i18n = inject('$i18n');
  const { state, getters, dispatch } = useStore();
  const props = defineProps({
    disabled: { type: Boolean, default: false },
  });

  const pointsNoun = $i18n.t('shoutouts.point', { count: 2 });
  const config = computed(() => state.bonusMilestoneConfigs.anniversary);

  // Accordion Selection
  const formatOptions = computed(() => [
      { title: 'Flat amount each year', value: 'default_only', disabled: props.disabled },
      { title: 'Celebrate each year and customize milestone years', value: 'custom_and_default', disabled: props.disabled },
      { title: 'Only send bonuses in specific milestone years', value: 'custom_only', disabled: props.disabled },
    ]);
  const { optionsWithStatus, startOptionSave, completeOptionSave } = useAccordionSaveStatus({ options: formatOptions });
  const formatSelection = computed({
    get() { return formatOptions.value.find(o => o.value === config.value.amount_mode); },
    set({ value }) {
      if (formatSelection.value?.value === value) return; // Clicking into a slotted input will read as a selection, just break out early if you can.

      const params = { amount_mode: value };
      if (value !== 'default_only' && !config.value.points_by_year) params.points_by_year = { 1: 20, 5: 30, 10: 40 };
      if (value !== 'custom_only' && !config.value.default_points) params.default_points = 10; // 10 is consistent with the defaultValue in Points::Config#anniversary_milestone_config
      startOptionSave(value);
      dispatch('bonusMilestoneConfigs/updateMilestoneConfig', { type: 'anniversary', params })
        .then(() => completeOptionSave(value));
    },
  });
</script>
